import './MarketSlider.less';

import clsx from 'clsx';
import React from 'react';
import { useReframe } from 'nike-re-framejs';

import { firstToUpperCase, handleDispatch } from '@/common/client';
import LoaderLinear from '@/ui/views/LoaderLinear';
import i18n from '@i18n';
import DefaultSubSlider from '@/common/components/DefaultSubSlider';
import { changeBoxMarket } from '@/nikeone/handlers';

function Market({ boxStore, boxId, marketId, active }) {
    const derefSub = useReframe();
    const market = derefSub(['nikeone/market', boxStore, marketId]);
    return (
        <a
            className={clsx('market-item', { active })}
            onClick={handleDispatch(changeBoxMarket(boxStore, boxId, marketId))}
            data-atid={'market-item ' + (active ? 'active' : '')}
        >
            {firstToUpperCase(market.get('name'))}
        </a>
    );
}

function EmptyOfferMessage() {
    return (
        <div className="alert alert-transparent">
            <p>{i18n('market.info.none')}</p>
        </div>
    );
}

function MarketSlider({ boxStore, boxId, children }) {
    const derefSub = useReframe();
    const boxMarketStatus = derefSub(['nikeone/box/getBoxMarketStatus', boxStore, boxId]);
    if (boxMarketStatus === 'NONE') {
        return null;
    }

    const showMarkets = derefSub(['nikeone/box/isShowMarkets', boxStore, boxId]);
    if (!showMarkets) {
        return children;
    }

    const marketIds = derefSub(['nikeone/box/marketShortcutIds', boxStore, boxId]);
    if (marketIds.size < 2) {
        return children;
    }
    const loadingMarket = derefSub(['nikeone/loading/market', boxId]);
    const selectedMarketIds = derefSub(['nikeone/box/selectedMarketIds', boxStore, boxId]);

    const activeMarket = marketIds.find(marketId => selectedMarketIds.contains(marketId));
    const shortcuts = marketIds.map(marketId => (
        <Market
            boxStore={boxStore}
            boxId={boxId}
            marketId={marketId}
            active={marketId === activeMarket}
            key={marketId}
        />
    ));
    return (
        <>
            <DefaultSubSlider className="nikeone-market-slider ml-5">{shortcuts}</DefaultSubSlider>
            <LoaderLinear show={loadingMarket} clazz="linear-loader-snap-top" />
            {boxMarketStatus === 'SELECT_ANOTHER_MARKET' && <EmptyOfferMessage />}
            {React.cloneElement(children, { activeShortcutMarketId: activeMarket })}
        </>
    );
}
export default MarketSlider;
